/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/no-danger */
import { useForm } from '@folklore/forms';
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useApi } from '../../contexts/ApiContext';
import { useSite } from '../../contexts/SiteContext';
import Button from '../buttons/Button';
import FormGroup from '../fields/FormGroup';
import TextField from '../fields/Text';
// import * as AppPropTypes from '../../lib/PropTypes';
import Label from './Label';
import Link from './Link';

import styles from '../../../styles/partials/newsletter-footer.module.scss';

import bg from '../../../img/doggy-fluo.png';

const propTypes = {
    visible: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    visible: false,
    className: null,
};

const NewsletterFooter = ({ visible, className }) => {
    const intl = useIntl();
    const route = useUrlGenerator();
    const api = useApi();
    const site = useSite();
    const { handle: siteHandle = null } = site || {};

    const [success, setSuccess] = useState(false);

    const socialMediaLinks = [
        {
            external: true,
            label: 'Facebook',
            url: 'https://facebook.com/urbania.media',
        },
        {
            external: true,
            label: 'Instagram',
            url: 'https://www.instagram.com/urbania.media/',
        },
        {
            external: true,
            label: 'Twitter',
            url: 'https://twitter.com/URBANIAMedia',
        },
        {
            external: true,
            label: 'LinkedIn',
            url: 'https://fr.linkedin.com/company/urbaniamedia',
        },
    ];

    const subscribe = useCallback(
        (action, data) => api.newsletter.subscribe({ ...data, site: siteHandle }),
        [api, siteHandle],
    );

    const onSuccess = useCallback(() => {
        setSuccess(true);
    }, [setSuccess]);

    const { fields, onSubmit } = useForm({
        postForm: subscribe,
        fields: ['email'],
        value: null,
        onComplete: onSuccess,
    });

    // TODO: Manage onSuccess better
    // Clear it on success
    useEffect(() => {
        const { onChange: onChangeEmail } = fields.email;
        if (success && onChangeEmail !== null) {
            onChangeEmail('');
        }
    }, [success]);

    // const {
    //     ref,
    //     entry: { isIntersecting = false },
    // } = useIntersectionObserver({ rootMargin: '-20%' });
    // console.log(isIntersecting);

    // const isIntersecting = true;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withLogo]: visible,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.doggy}>
                    <img className={styles.doggyImg} src={bg} alt="Doggy dog" />
                </div>

                <div className={styles.subscribe}>
                    <div className={styles.newsletter}>
                        <h3 className={styles.subtitle}>
                            <Label>
                                {siteHandle === 'france' ? (
                                    <FormattedMessage
                                        defaultMessage="Subscribe to our{br}corporate (but never dry!){br}newsletter"
                                        description="Subscribe newsletter subtitle france"
                                        values={{ br: <br /> }}
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Subscribe to our{br}corporate (but never dry!){br}newsletter"
                                        description="Subscribe newsletter subtitle"
                                        values={{ br: <br /> }}
                                    />
                                )}
                            </Label>
                        </h3>
                        {!success ? (
                            <form
                                className={styles.formContainer}
                                action={route('api.newsletter.subscribe')}
                                onSubmit={onSubmit}
                            >
                                <FormGroup
                                    className={styles.formGroup}
                                    {...fields.email}
                                    label={
                                        siteHandle === 'france' ? (
                                            <FormattedMessage
                                                defaultMessage="Email"
                                                description="Field label france"
                                            />
                                        ) : (
                                            <FormattedMessage
                                                defaultMessage="Email"
                                                description="Field label"
                                            />
                                        )
                                    }
                                >
                                    <TextField
                                        {...fields.email}
                                        className={classNames(styles.input, styles.inputText)}
                                        type="email"
                                        required
                                        autocomplete="off"
                                        placeholder={
                                            siteHandle === 'france'
                                                ? intl.formatMessage({
                                                      defaultMessage: 'your@email.ca',
                                                      description:
                                                          'Subscribe newsletter input placeholder france',
                                                  })
                                                : intl.formatMessage({
                                                      defaultMessage: 'your@email.ca',
                                                      description:
                                                          'Subscribe newsletter input placeholder',
                                                  })
                                        }
                                    />
                                </FormGroup>
                                <Button className={styles.submit} type="submit">
                                    →
                                </Button>
                            </form>
                        ) : (
                            <div className={classNames([styles.subtitle, styles.thanks])}>
                                <FormattedMessage
                                    defaultMessage="Thanks!"
                                    description="Newsletter label"
                                />
                            </div>
                        )}
                    </div>
                    <div className={styles.social}>
                        <h3 className={styles.subtitle}>
                            <FormattedMessage
                                defaultMessage="Follow us"
                                description="Social media heading"
                            />
                        </h3>
                        <div className={styles.socialLinks}>
                            {(socialMediaLinks || []).map(({ url = null, label = null }) => (
                                <Link
                                    key={`item-${url}`}
                                    className={styles.socialLink}
                                    href={url}
                                    external
                                >
                                    {label}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

NewsletterFooter.propTypes = propTypes;
NewsletterFooter.defaultProps = defaultProps;

export default NewsletterFooter;
